<template>
    <div class="aspect-video bg-gray-200 mb-2 overflow-hidden rounded border border-blog-beige shadow-sm w-full md:w-auto"
        v-if="course && course.className">
        <img :src="course.getCoursePhoto()" alt="course photo"
            class="w-full h-full object-cover" />
    </div>
</template>

<script setup>
import { onMounted, ref, defineProps, watch } from 'vue';

const props = defineProps({
    course: {
        type: Object,
        required: true,
        default: () => ({})
    }
});

const course = ref(null);
onMounted(() => {
    course.value = props.course;
});

watch(() => props.course, (newValue) => {
    course.value = newValue;
},
    { deep: true }
);

</script>